var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPmd(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.00006 22.7144C6.4834 22.7144 6.0334 22.5477 5.65006 22.2144C5.26673 21.881 5.05006 21.456 5.00006 20.9394L3.12506 3.81436C3.09173 3.51436 3.17506 3.25602 3.37506 3.03936C3.57506 2.82269 3.82506 2.71436 4.12506 2.71436H19.8751C20.1751 2.71436 20.4251 2.82269 20.6251 3.03936C20.8251 3.25602 20.9084 3.51436 20.8751 3.81436L19.0001 20.9394C18.9501 21.456 18.7334 21.881 18.3501 22.2144C17.9667 22.5477 17.5167 22.7144 17.0001 22.7144H7.00006ZM17.2251 18.7144H6.77506L7.00006 20.7144H17.0001L17.2251 18.7144ZM5.22506 4.71436L6.55006 16.7144H17.4501L18.7501 4.71436H5.22506Z",
    fill: "#585858"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPmd);
export default __webpack_public_path__ + "static/media/PMD.3b8f593d54999da8cddd105955e2c6df.svg";
export { ForwardRef as ReactComponent };